import React from 'react';

import PropTypes from 'prop-types';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const ImageViewer = (props) => {
  const { wrapperClassName, componentClassName, children, transformWrapperProperties } = props;

  const transformComponentProperties = {
    wrapperClass: wrapperClassName,
    contentClass: componentClassName

  };

  return (
    <TransformWrapper {...transformWrapperProperties}>
      <TransformComponent {...transformComponentProperties}>
        {children}
      </TransformComponent>
    </TransformWrapper>
  );
};

export default ImageViewer;

ImageViewer.propTypes = {
  wrapperClassName: PropTypes.string,
  componentClassName: PropTypes.string,
  children: PropTypes.element,
  transformWrapperProperties: PropTypes.shape({})
};

ImageViewer.defaultProps = {
  wrapperClassName: '',
  componentClassName: '',
  children: <></>,
  transformWrapperProperties: {}

};
